module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "list-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, _vm._l((_vm.list), function(option) {
    return _c('div', {
      staticClass: "list-popover__option",
      class: _vm.optionClass(option.value),
      style: (_vm.optionStyle),
      attrs: {
        "id": ("popover-box-option-" + (option.name))
      },
      on: {
        "click": function($event) {
          return _vm.selectOption(option.value)
        }
      }
    }, [_vm._v("\n    " + _vm._s(option.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f89c1f22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/ListPopover.vue
// module id = 2007
// module chunks = 0